
/* Expanding the Details row by default on the Product Page */
document.addEventListener('DOMContentLoaded', () => {
  const productInfo = document.querySelector('.product__info-container');
  if (!productInfo) return;

  const accordions = productInfo.querySelectorAll('.product__accordion details');
  const duration = 280; // adjust speed here: 220 faster, 350 slower
  const easing = 'ease';

  function openAccordion(details) {
    const summary = details.querySelector('summary');
    if (!summary || details.open) return;

    details.style.overflow = 'hidden';
    details.style.height = `${summary.offsetHeight}px`;
    details.setAttribute('open', '');

    requestAnimationFrame(() => {
      details.style.transition = `height ${duration}ms ${easing}`;
      details.style.height = `${details.scrollHeight}px`;
    });

    setTimeout(() => {
      details.style.height = '';
      details.style.overflow = '';
      details.style.transition = '';
    }, duration);
  }

  function closeAccordion(details) {
    const summary = details.querySelector('summary');
    if (!summary || !details.open) return;

    details.style.overflow = 'hidden';
    details.style.height = `${details.scrollHeight}px`;

    requestAnimationFrame(() => {
      details.style.transition = `height ${duration}ms ${easing}`;
      details.style.height = `${summary.offsetHeight}px`;
    });

    setTimeout(() => {
      details.removeAttribute('open');
      details.style.height = '';
      details.style.overflow = '';
      details.style.transition = '';
    }, duration);
  }

  accordions.forEach((details) => {
    const summary = details.querySelector('summary');
    if (!summary) return;

    const summaryText = summary.textContent.trim().toLowerCase();

    // Open Details by default
    if (summaryText.includes('details')) {
      details.setAttribute('open', '');
    }

    summary.addEventListener('click', (event) => {
      event.preventDefault();

      if (details.open) {
        closeAccordion(details);
      } else {
        accordions.forEach((otherDetails) => {
          if (otherDetails !== details && otherDetails.open) {
            closeAccordion(otherDetails);
          }
        });

        openAccordion(details);
      }
    });
  });
});



/* Move / format the Shop Pay element after Add to Cart */

document.addEventListener('DOMContentLoaded', () => {
  const productInfo = document.querySelector('.product__info-container');
  if (!productInfo) return;

  const paymentTerms = productInfo.querySelector('shopify-payment-terms');
  const addToCartButton = productInfo.querySelector('.product-form__submit');

  if (paymentTerms && addToCartButton) {
    addToCartButton.insertAdjacentElement('afterend', paymentTerms);
    paymentTerms.classList.add('gb-payment-terms-moved');
  }
});